import AppRoutes from 'routes/AppRoutes';

import { BrowserRouter } from 'react-router-dom';

import ErrorBoundary from 'components/ErrorBoundary';
import SessionTimeoutProvider from 'components/SessionTimeout/SessionTimeoutProvider';
import SessionValidationGate from 'components/SessionValidationGate';

import 'App.css';

const App = () => (
  <ErrorBoundary>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <SessionValidationGate>
        <SessionTimeoutProvider>
          <AppRoutes />
        </SessionTimeoutProvider>
      </SessionValidationGate>
    </BrowserRouter>
  </ErrorBoundary>
);

export default App;
